function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "account_balance-24px",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_245",
  "data-name": "Trazado 245",
  d: "M0,0H31.5V31.5H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_246",
  "data-name": "Trazado 246",
  d: "M4.526,14.4v5.132a1.895,1.895,0,1,0,3.789,0V14.4a1.895,1.895,0,1,0-3.789,0Zm7.579,0v5.132a1.895,1.895,0,1,0,3.789,0V14.4a1.895,1.895,0,1,0-3.789,0ZM3.895,27.871H24.105a1.925,1.925,0,0,0,0-3.849H3.895a1.925,1.925,0,0,0,0,3.849ZM19.684,14.4v5.132a1.895,1.895,0,1,0,3.789,0V14.4a1.895,1.895,0,1,0-3.789,0ZM12.825,1.556,2.846,6.893a1.6,1.6,0,0,0,.733,3.015H24.434a1.6,1.6,0,0,0,.72-3.015L15.175,1.556a2.462,2.462,0,0,0-2.349,0Z",
  transform: "translate(1 0.629)",
  fill: "#dde8f1"
}));

var SvgBank = function SvgBank(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.5,
    height: 31.5,
    viewBox: "0 0 31.5 31.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBank, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bank.e2d02f4a.svg";
export { ForwardRef as ReactComponent };